import axios from "axios";
import { getUserToken } from "../../utils/localStoarege";
import { accountDashboardApi } from "../../constants/apis/account_apis";
import { exportConsultationExcelApi, exportMedicineCenterReportApi, exportMedicineExcelApi, exportPackageExcelApi } from '../../constants/apis/account_apis';

export const exportAccountPackageInvoice = async (center, fromDate, toDate) => {
    window.open(exportPackageExcelApi + center + "/" + fromDate + "/" + toDate + "/", "_blank");
    return { status: 200 };
};

export const exportAccountConsultationInvoice = async (center, fromDate, toDate) => {
    window.open(exportConsultationExcelApi + center + "/" + fromDate + "/" + toDate + "/", "_blank");
    return { status: 200 };
};

export const exportAccountMedicineInvoice = async (center, fromDate, toDate) => {
    window.open(exportMedicineExcelApi + center + "/" + fromDate + "/" + toDate + "/", "_blank");
    return { status: 200 };
};

export const exportAccountMedicineCenterReport = async (startDate, endDate, centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
        params: {
            start_date: startDate,
            end_date: endDate,
            center_name: centerName,
            download: true,
        },
        responseType: "blob",
    };

    const response = await axios.get(exportMedicineCenterReportApi, config);

    const fileBlob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
    });
    const fileUrl = window.URL.createObjectURL(fileBlob);
    const fileLink = document.createElement("a");
    const disposition = response.headers["content-disposition"] || "";
    const match = disposition.match(/filename="?([^"]+)"?/);
    const fallbackFileName = `medicine-report-center-${startDate}-to-${endDate}.xlsx`;

    fileLink.href = fileUrl;
    fileLink.setAttribute("download", match?.[1] || fallbackFileName);
    document.body.appendChild(fileLink);
    fileLink.click();
    fileLink.remove();
    window.URL.revokeObjectURL(fileUrl);

    return { status: response.status };
};

export const getAccountHome = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(
        accountDashboardApi,
        config,
    );

    return response;
};
